import moment from 'moment';

import { FlagPricing } from '@hivebrite/design-system/Flag';

import type { Event } from 'hb-react/shared/apps/Events/types';

import EventPricingTagLazy from './lazy';

interface EventPricingTagProps {
  event: Pick<
    Event,
    'id' | 'display_price_tag' | 'tickets_due_date' | 'participation_type'
  >;
}

const EventPricingTag = (props: EventPricingTagProps) => {
  const { event } = props;

  if (
    !event.display_price_tag ||
    (event.tickets_due_date && moment(event.tickets_due_date).isBefore())
  ) {
    return null;
  }

  // Display 'Free'
  if (event.participation_type === 'rsvp') {
    return <FlagPricing />;
  }

  return <EventPricingTagLazy {...props} />;
};

export default EventPricingTag;
